const SkipLink = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-accent focus:text-accent-foreground focus:font-semibold focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground focus-visible:ring-offset-2"
  >
    Skip to main content
  </a>
);

export default SkipLink;
